import React from 'react';
import { useLanguage } from "@src/context/LanguageContext";
function Footer() {
    const {translations} = useLanguage();

    return (
        <footer>
            <div className="container-fluid">
                <div className="footer-txt">
                    <span className="copyright-txt">© {translations.footer?.['Insurance_All_Rights_Reserved'] || translations.commonMsg?.loading}</span>
                    <ul className="footer-link">
                        <li className=""><a href="/#">{translations.footer?.['Terms_Conditions'] || translations.commonMsg?.loading}</a> </li>
                        <li className=""><a href="/#">{translations.footer?.['Privacy_Policy'] || translations.commonMsg?.loading}</a> </li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;